<template>
  <el-form inline size="mini" :model="formData" :rules="rules" ref="form">
    <div class="card-title card-title--left" style="">乙方信息</div>
    <div class="form-card" :class="{disabled}">
      <el-form-item label="乙方名称" prop="company_id">
        <company-select
            v-if="editField==='company_name'||!formData.company_name"
            :key="type"
            :company-id.sync="formData.company_id"
            :project-type="type"
            @selected="currentCompany"
            style="display: inline;width: 200px"/>
        <div v-else class="input-val" @click="selectEditField">
          <span class="company_name form-val">{{ formData.company_name }}</span>
        </div>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import CompanySelect from "@/views/adOrder/components/companySelect";
import {PT_CZB, PT_NK, PT_PK, PT_PT, PT_QA} from "@/views/adOrder";


/**
 * 乙方模块 PartyB
 * @description 保存订单页面
 */
export default {
  name: "PartBasePartyB",
  components: {CompanySelect},
  props: {
    formData: {
      type: Object,
      required: true
    },
    editField: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rules() {
      return this.$parent.rules
    },
    type() {
      /**
       * 普通订单 formData.project_type是假&&is_mark是假&&form_of_cooperation！== '纯直播'
       * 普客打包 formData.project_type === 3
       * 全案营销 formData.is_mark === 1 && form_of_cooperation !== '年框大全案'
       * 年框大全案 formData.is_mark === 1 && form_of_cooperation === '年框大全案'
       * 纯直播 路由 isPureLive=true||form_of_cooperation === '纯直播'
       */
      const {project_type, is_mark, form_of_cooperation} = this.formData

      if (!project_type && !is_mark && form_of_cooperation !== '纯直播') {
        // 普通订单
        return PT_PT
      }
      if (project_type === 3) {
        // 普客打包
        return PT_PK
      }
      if (is_mark === 1 && form_of_cooperation !== '年框大全案') {
        // 全案营销
        return PT_QA
      }
      if (is_mark === 1 && form_of_cooperation === '年框大全案') {
        // 年框大全案
        return PT_NK
      }
      if (form_of_cooperation === '纯直播') {
        // 纯直播
        return PT_CZB
      }
      // 普通订单
      return PT_PT
    }
  },
  methods: {
    validateForm() {
      let form = Object.assign({}, this.formData);
      this.$refs.form.validate((bool) => {
        if (!bool) {
          form = bool
        }
      });
      return form
    },
    /**
     * 选择乙方 change事件
     * @param option
     */
    currentCompany(option) {
      option = option || {value: null, label: null};
      this.formData.company_id = option.value;
      this.formData.company_name = option.label;
      this.$emit('update:edit-field', null);
    },
    selectEditField: function () {
      this.$emit('selectEditField', 'company_name')
    }
  }
}
</script>

<style scoped>
.card-title.card-title--left {
  padding-left: 34px !important;
}

.card-title--left::after {
  left: 22px !important;
}
::v-deep {
  .el-form-item {
    margin-right: 0;
    min-height: 36px;
  }
}

</style>
